import { render, staticRenderFns } from "./ReceivableHistory.vue?vue&type=template&id=24fcd93c&scoped=true&"
import script from "./ReceivableHistory.vue?vue&type=script&lang=js&"
export * from "./ReceivableHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReceivableHistory.vue?vue&type=style&index=0&id=24fcd93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fcd93c",
  null
  
)

export default component.exports